import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Startups } from '../models/startups';
import { Startups_likes } from '../models/startups_likes';

@Injectable({
  providedIn: 'root'
})

export class StartupsLikesService extends CrudService<Startups_likes, number> {

  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/startups_likes`);
  }

}



